import React, { ReactElement } from "react";
import { Redirect, Route } from "react-router-dom";

interface AuthenticatedRouteProps {
  component: React.FC;
  authenticated: boolean;
  path:string;
  exact:boolean;
}

interface ValidProfileRouteProps extends AuthenticatedRouteProps {
  isUserProfileValid: boolean;
}

export const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({
  component: Component,
  authenticated,
  ...rest
}): ReactElement => (
  <Route
    {...rest}
    render={() => (authenticated ? <Component {...rest} /> : <Redirect to="/login" />)}
  />
);

export const ValidProfileRoute: React.FC<ValidProfileRouteProps> = ({
  component: Component,
  authenticated,
  isUserProfileValid,
  ...rest
}): ReactElement => (
  <Route
    {...rest}
    render={() =>
      authenticated && isUserProfileValid ? <Component {...rest} /> : <Redirect to="/" />
    }
  />
);